import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Home, UtensilsCrossed, Refrigerator, ShoppingCart } from "lucide-react";
import { MILLIE } from "../lib/millie";

const items = [
  { to: "/home", label: "Home", icon: Home, testId: "nav-home" },
  { to: "/meals", label: "Meals", icon: UtensilsCrossed, testId: "nav-meals" },
  { to: "/kitchen", label: "Kitchen", icon: Refrigerator, testId: "nav-kitchen" },
  { to: "/shopping", label: "Shopping", icon: ShoppingCart, testId: "nav-shopping" },
];

export default function BottomNav() {
  const loc = useLocation();
  const navigate = useNavigate();
  const millieActive = loc.pathname === "/millie";
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-40 pointer-events-none" data-testid="bottom-nav">
      <div className="pointer-events-auto relative bg-white/90 backdrop-blur-xl border-t-2 border-[#FDECEF] px-3 pt-2 pb-3 flex items-end justify-between" style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}>
        {items.slice(0, 2).map(({ to, label, icon: Icon, testId }) => (
          <NavItem key={to} to={to} label={label} Icon={Icon} testId={testId} active={loc.pathname === to} />
        ))}

        {/* Center Ask Millie */}
        <button
          onClick={() => navigate("/millie")}
          data-testid="nav-millie"
          className="flex flex-col items-center gap-1 -mt-8 w-[22%]"
        >
          <span className={`w-16 h-16 rounded-full overflow-hidden border-4 ${millieActive ? "border-sorted-rose" : "border-white"} shadow-floating bg-sorted-blush transition-colors`}>
            <img src={MILLIE.avatar} alt="Ask Millie" className="w-full h-full object-cover object-top" />
          </span>
          <span className={`text-[11px] font-bold ${millieActive ? "text-sorted-rose" : "text-sorted-ink"}`}>Ask Millie</span>
        </button>

        {items.slice(2).map(({ to, label, icon: Icon, testId }) => (
          <NavItem key={to} to={to} label={label} Icon={Icon} testId={testId} active={loc.pathname === to} />
        ))}
      </div>
    </nav>
  );
}

function NavItem({ to, label, Icon, testId, active }) {
  return (
    <NavLink to={to} data-testid={testId} className="flex flex-col items-center gap-0.5 w-[19%] py-1">
      <Icon size={22} strokeWidth={2.5} className={active ? "text-sorted-rose" : "text-sorted-slate"} />
      <span className={`text-[11px] font-bold ${active ? "text-sorted-rose" : "text-sorted-slate"}`}>{label}</span>
    </NavLink>
  );
}
